import React, { useState } from "react";
import {
  Modal,
  Box,
  Button,
  Typography,
  FormControl,
  TextField,
} from "@mui/material";

const RefillReminderModal = ({ open, onClose, onSubmit }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dob, setDob] = useState("");
  const [rxNumber, setRxNumber] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [submissionStatus, setSubmissionStatus] = useState(null);

  // Validate that the RX number is 6-12 digits
  const isValidRx = /^[0-9]{5,12}$/.test(rxNumber);

  // Ensure required fields are provided and RX is valid
  const isValidForm =
    // firstName.trim() !== "" &&
    // lastName.trim() !== "" &&
    dob.trim() !== "" &&
    // email.trim() !== "" &&
    // phoneNumber.trim() !== "" &&
    isValidRx;

  const handleSubmit = async () => {
    if (!isValidForm) return;
    try {
      const response = await onSubmit({
        // first_name: firstName,
        // last_name: lastName,
        date_of_birth: dob,
        rx_number: rxNumber,
        // email: email,
        // phone_number: phoneNumber,
      });

      if (response.ok) {
        setSubmissionStatus("success");
      } else {
        setSubmissionStatus("failure");
      }
    } catch (error) {
      console.error("Error submitting refill request:", error);
      setSubmissionStatus("failure");
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ ...modalStyle }}>
        <Typography variant="h6" mb={2}>
          Sign Up for Refill Reminder
        </Typography>

        {/* If submissionStatus is set, show success/failure message. Otherwise, show the form. */}
        {submissionStatus ? (
          submissionStatus === "success" ? (
            <>
              <Typography mb={2}>
                Your request has been submitted successfully!
              </Typography>
              <Button onClick={onClose} variant="contained" color="primary">
                Close
              </Button>
            </>
          ) : (
            <>
              <Typography mb={2}>
                Submission failed. Please try again later.
              </Typography>
              <Button onClick={onClose} variant="contained" color="primary">
                Close
              </Button>
            </>
          )
        ) : (
          <>
            {/* <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <FormControl fullWidth>
                <TextField
                  label="First Name"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  required
                />
              </FormControl>
              <FormControl fullWidth>
                <TextField
                  label="Last Name"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  required
                />
              </FormControl>
            </Box> */}

            <FormControl fullWidth sx={{ mb: 2 }}>
              <TextField
                label="Date of Birth"
                type="date"
                value={dob}
                onChange={(e) => setDob(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{ max: new Date().toISOString().split("T")[0] }}
                required
              />
            </FormControl>

            {/* <FormControl fullWidth sx={{ mb: 2 }}>
              <TextField
                label="Email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </FormControl>

            <FormControl fullWidth sx={{ mb: 2 }}>
              <TextField
                label="Phone Number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                required
              />
            </FormControl> */}

            <FormControl fullWidth sx={{ mb: 2 }}>
              <TextField
                label="Prescription RX Number"
                value={rxNumber}
                onChange={(e) => setRxNumber(e.target.value)}
                error={rxNumber.length > 0 && !isValidRx}
                helperText={
                  rxNumber.length > 0 && !isValidRx
                    ? "RX numbers must be 5-12 digits"
                    : ""
                }
                required
              />
            </FormControl>

            <Button
              onClick={handleSubmit}
              variant="contained"
              color="primary"
              disabled={!isValidForm}
            >
              Submit
            </Button>
          </>
        )}
      </Box>
    </Modal>
  );
};

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

export default RefillReminderModal;
